import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Scrolls to the top of the page on route changes, but NOT on language switches.
 * A language switch is a navigation where only the leading language prefix changes,
 * e.g. /fr/privacy -> /en/privacy. In that case, preserve scroll position.
 */
const stripLang = (path) => {
  if (!path) return "/";
  if (path.startsWith("/fr")) return path.slice(3) || "/";
  if (path.startsWith("/en")) return path.slice(3) || "/";
  return path;
};

export const ScrollToTop = () => {
  const location = useLocation();
  const prevPathRef = React.useRef(location.pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    const next = location.pathname;
    if (prev === next) return;

    const prevStripped = stripLang(prev);
    const nextStripped = stripLang(next);

    const isLangSwitchOnly = prevStripped === nextStripped;
    if (!isLangSwitchOnly) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
    prevPathRef.current = next;
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
